import PropTypes from 'prop-types';

const ClockSvg = ({ color, width, height }) => {
  return (
    <svg
      width={`${width || 40}`}
      height={`${height || 40}`}
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M20.5026 36.6667C29.7074 36.6667 37.1693 29.2048 37.1693 20C37.1693 10.7953 29.7074 3.33337 20.5026 3.33337C11.2979 3.33337 3.83594 10.7953 3.83594 20C3.83594 29.2048 11.2979 36.6667 20.5026 36.6667Z"
        fill={color}
      />
      <path
        d="M26.6818 26.5501C26.4651 26.5501 26.2484 26.5001 26.0484 26.3667L20.8818 23.2834C19.5984 22.5167 18.6484 20.8334 18.6484 19.3501V12.5167C18.6484 11.8334 19.2151 11.2667 19.8984 11.2667C20.5818 11.2667 21.1484 11.8334 21.1484 12.5167V19.3501C21.1484 19.9501 21.6484 20.8334 22.1651 21.1334L27.3318 24.2167C27.9318 24.5667 28.1151 25.3334 27.7651 25.9334C27.5151 26.3334 27.0984 26.5501 26.6818 26.5501Z"
        fill={color}
      />
    </svg>
  );
};

ClockSvg.propTypes = {
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default ClockSvg;
